import React from 'react'
import Dropdown from 'components/common/dropdowns/Dropdown'
import { usePartnerComissionTypes } from 'hooks/api/usePartnerCommissionTypes'
import { Row, Col } from 'react-bootstrap'
import Text from 'components/common/Text'
import FormLabel from 'components/common/forms/elements/FormLabel'
import { COLORS } from 'utility/colors'
import { useTenantSettings } from 'hooks/api/tenant/useTenantSettings'
import Card from 'components/common/cards/Card'
import colors from 'utility/colors'

const NonprofitDropdown = ({ partner, enterprisePartnerSlug, onSelect, value }) => {
	const { data: commissionTypeList } = usePartnerComissionTypes(enterprisePartnerSlug)
	const { data: settings } = useTenantSettings()

	let options
	if (partner) {
		console.log('Using Partner for NonProfit List', partner.referralCommissionOptions)
		options = partner.referralCommissionOptions
	} else {
		console.log('Using Commission Types from Enterprise', enterprisePartnerSlug)
		options = commissionTypeList
	}

	const hasOptions = options && options.length > 0
	const defaultTitle = hasOptions ? 'Select a beneficiary (optional)' : 'No beneficiaries available'

	const labelColorStyle = {
		color: COLORS.WHITE,
	}

	if (!hasOptions) return null

	return (
		<Card
			noShadow
			style={{
				backgroundColor: colors.MUTED_GRAY,
				display: 'flex',
				flexDirection: 'column',
				gap: 20,
			}}
		>
			<Row>
				<Col xs='12'>
					<Text
						size={14}
						style={{
							color: COLORS.GRAY,
						}}
					>
						Signup 20+ homes for {settings?.signupYear} and qualify to earn referral commissions for
						your business or a Texas housing non-profit.
					</Text>
				</Col>
				<Col xs='12'>
					<FormLabel
						style={{ ...labelColorStyle, fontWeight: 'bold', marginBottom: 5, color: COLORS.GRAY }}
					>
						SEND MY REFERRAL COMMISSIONS TO:
					</FormLabel>
					<Dropdown
						cardStyle={{ width: '100%', position: 'relative' }}
						style={{ width: '100%' }}
						defaultTitle={defaultTitle}
						disabled={!hasOptions}
						options={options?.map((opt) => {
							const isRule = opt === 'BREAK'
							return {
								title: opt,
								rule: isRule,
								onClick: onSelect,
							}
						})}
					>
						{value}
					</Dropdown>
				</Col>
			</Row>
		</Card>
	)
}

export default NonprofitDropdown
